import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const GuestAPI = {
  getGuestsList: async (token, queryParams = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/guest/list`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },
};

export default GuestAPI;
